module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-edit"
  }, [_c('div', {
    staticClass: "product-edit__content"
  }, [_c('router-link', {
    staticClass: "close",
    attrs: {
      "to": "/products/"
    }
  }, [_vm._v("Закрыть")]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__props"
  }, [_c('div', {
    staticClass: "product-edit__prop"
  }, [_vm._v("ID: " + _vm._s(_vm.product.groupId))]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__prop"
  }, [_vm._v("Кластер: " + _vm._s(_vm.product.cluster ? _vm.product.cluster.title : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__two-cols"
  }, [_c('div', {
    staticClass: "product-edit__inputs"
  }, [_c('div', {
    staticClass: "product-edit__size form-block"
  }, [_c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Размер")]), _vm._v(" "), _c('input-material', {
    attrs: {
      "parentClass": "inline",
      "label": "Ширина",
      "type": "number",
      "valueNumber": _vm.product.width
    },
    on: {
      "inputNumber": function($event) {
        _vm.width = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('input-material', {
    attrs: {
      "parentClass": "inline",
      "label": "Высота",
      "type": "number",
      "valueNumber": _vm.product.height
    },
    on: {
      "inputNumber": function($event) {
        _vm.height = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('input-material', {
    attrs: {
      "parentClass": "inline",
      "label": "Глубина",
      "type": "number",
      "valueNumber": _vm.product.depth
    },
    on: {
      "inputNumber": function($event) {
        _vm.depth = $event
      }
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Фотографии упаковки")]), _vm._v(" "), _c('div', {
    staticClass: "pictures"
  }, [_c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.FRONT,
      "type": "FRONT",
      "label": "Перед"
    },
    on: {
      "uploaded": _vm.frontUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.TOP,
      "type": "TOP",
      "label": "Верх"
    },
    on: {
      "uploaded": _vm.topUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.RIGHT,
      "type": "RIGHT",
      "label": "Правая стенка"
    },
    on: {
      "uploaded": _vm.rightUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.LEFT,
      "type": "LEFT",
      "label": "Левая стенка"
    },
    on: {
      "uploaded": _vm.leftUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.BACK,
      "type": "BACK",
      "label": "Задняя стенка"
    },
    on: {
      "uploaded": _vm.backUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.BOTTOM,
      "type": "BOTTOM",
      "label": "Низ"
    },
    on: {
      "uploaded": _vm.bottomUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__image"
  }, [_c('div', {
    staticClass: "product-edit__change-camera"
  }, _vm._l((_vm.cameraViews), function(view) {
    return _c('div', {
      staticClass: "camera-angle",
      class: [{
        active: (view.id === _vm.currentCameraView)
      }, view.id],
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentCameraView = view.id
        }
      }
    }, [_vm._v(_vm._s(view.title) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zoom"
  }, _vm._l((_vm.cameraZooms), function(zoom) {
    return _c('div', {
      staticClass: "zoom__item",
      class: {
        active: (zoom.value === _vm.currentCameraZoom)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.previousCameraZoom = _vm.currentCameraZoom;
          _vm.currentCameraZoom = zoom.value
        }
      }
    }, [_vm._v(_vm._s(zoom.title) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "product-edit__camera",
    style: (_vm.cameraPosition)
  }, [_c('pack', {
    staticClass: "pack-position",
    style: (_vm.packStyle),
    attrs: {
      "initWidth": _vm.previewWidth,
      "initHeight": _vm.previewHeight,
      "initDepth": _vm.previewDepth,
      "initFrontImg": _vm.photos.FRONT,
      "initTopImg": _vm.photos.TOP,
      "initRightImg": _vm.photos.RIGHT,
      "initLeftImg": _vm.photos.LEFT,
      "initBottomImg": _vm.photos.BOTTOM,
      "initBackImg": _vm.photos.BACK,
      "isMirrored": false,
      "x": -110,
      "y": -50,
      "z": 0
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__exit"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("Сохранить и закрыть")]), _vm._v(" "), _c('router-link', {
    staticClass: "close-without-save",
    attrs: {
      "to": "/products/"
    }
  }, [_vm._v("Закрыть без сохранения")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10e80970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/ProductEdit.vue
// module id = 230
// module chunks = 1